import { render, staticRenderFns } from "./TravelTravellerDobForm.vue?vue&type=template&id=8406382a&scoped=true"
import script from "./TravelTravellerDobForm.vue?vue&type=script&lang=js"
export * from "./TravelTravellerDobForm.vue?vue&type=script&lang=js"
import style0 from "./TravelTravellerDobForm.vue?vue&type=style&index=0&id=8406382a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8406382a",
  null
  
)

export default component.exports